module.exports = __webpack_public_path__ + "img/l2.8c7883e6.png";